import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from '../../../js/ComponentManager'

/* 개발담당:양유빈
 * 화면기능:주문유형
 * 세부설명:
*/

export class OrderType extends Component {
    static displayName = OrderType.name;

    constructor(props) {
        super(props);
        this.state = {
            OrdUse: [],
            PayIdx: [],
            WholeInfo: [],
            Paylist: [],
            Bill_Yn: "N",
            Refund_Yn: "N",
            SelectOrdCd: "",
            SelectPayCd: "",
            Title: "",
            Content:""

        };
        this.OrderTypeRef = React.createRef();
        this.handelOrdUse_Click = this.handelOrdUse_Click.bind(this);
        this.handlePayType_Click = this.handlePayType_Click.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handleAlert_Click = this.handleAlert_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)

        this.Qstgrp_no = "";
        this.Qst_status = "";
       
    }
    
    //초기화
    componentDidMount() {
        this.CallBaseInfoData();
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
        }
    }
    //도매아이디, 총 구매 금액(부모 페이지에서 받아옴)
    BasketInfo = [];    //장바구니 구매 리스트
    PriceSumInfo = [];  //도매별 총 구매비용
    async GoodsParameterSet(Model) {
        
        if (Model.length === 0) {
            return false;
        }
        this.BasketInfo = Model;

        //채팅주문 입력
        if (this.BasketInfo.length > 0) {
            this.Qstgrp_no = this.BasketInfo[0].qstgrp_no === undefined ? "" : this.BasketInfo[0].qstgrp_no;
            this.Qst_status = this.BasketInfo[0].qst_status === undefined ? "" : this.BasketInfo[0].qst_status;
        }
                       
        //PriceSumInfo의 총 구매비용 할당.
        let GroupByData = Big3Common.Util.groupBy(Model, list => list.uid);
        this.PriceSumInfo = [];
        for (const item of GroupByData.entries()) {
            let Uid = item[0];
            let PriceSum = item[1].map(list => list.goods_price * list.quan).reduce((Accumulator, currentValue) => Accumulator + currentValue);
            this.PriceSumInfo.push({ uid: Uid, pricesum: PriceSum });
        }        
        //도매매장 정보(계좌,은행,예금주 등) 가져오기
        let Data = await Big3Common.Post('api/MyPage/Basket/GetWholeBankInfo', { uidList: this.PriceSumInfo }, true);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            let WholeBankInfo = JSON.parse(Data.dataTable);
            this.setState({ WholeInfo: WholeBankInfo });
        }
        else {
            console.log(Data.message);
        }
        //택배비 결제할 도매매장
        let Data2 = await Big3Common.Post('api/MyPage/OrderMgr/GetOrderCheck', {}, true);
        if (Data2.codeName === Big3Common.ResultCode.Success) {
            let DataList = JSON.parse(Data2.dataTable);
            let OrderList = DataList
            let BasketList = this.BasketInfo.filter(basketItem => !OrderList.some(orderItem => orderItem.uid === basketItem.uid));
            let PaylistSet = new Set(BasketList.map(basketItem => basketItem.uid));
            let Paylist = Array.from(PaylistSet);
            this.setState({
                Paylist: Paylist
            });
        }
        else {
            console.log(Data.message);
        }
        
    }

    PayIdxData = [];
    //기준정보 조회
    async CallBaseInfoData() {
        try {

            //주문유형 
            let Data1 = await Big3Common.Get('api/Common/Common/GetBaseInfo/020');
            if (Data1.codeName === Big3Common.ResultCode.Success) {
                let OrdUse = JSON.parse(Data1.dataTable);
                //결재방식
                let Data2 = await Big3Common.Get('api/Common/Common/GetBaseInfo/010');
                if (Data2.codeName === Big3Common.ResultCode.Success) {
                    this.PayIdxData = JSON.parse(Data2.dataTable);
                }
                this.setState({ OrdUse: OrdUse });

            }
            else {
                console.log(Data1.message);
            }
        }
        catch (e) {
            console.log("CallBoorkMarkGoodsData", e);
        }
        return false;
    }
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    //주문유형 선택
    handelOrdUse_Click(event, list) {
        //택배주문(TJ):온라인입금(OL)
        //삼촌사입(SS):온라인입금(OL), 사입자 대납(SD)
        //현장방문(HB): 온라인입금(OL), 현장결재(HJ)
        let dtl_cd = list.dtl_cd;
        let PayIdxFilter = [];
        if (dtl_cd === "TJ") {
            PayIdxFilter = this.PayIdxData.filter(data => data.dtl_cd === "OL");
        }
        else if (dtl_cd === "SS") {
            PayIdxFilter = this.PayIdxData.filter(data => data.dtl_cd === "OL" || data.dtl_cd === "SD");
        }
        else if (dtl_cd === "HB") {
            PayIdxFilter = this.PayIdxData.filter(data => data.dtl_cd === "OL" || data.dtl_cd === "HJ");
        }
        this.setState({
            SelectOrdCd: dtl_cd,
            PayIdx: PayIdxFilter,
            SelectPayCd: (dtl_cd === 'TJ' ? 'OL' : '')
        });
        event.preventDefault();
    }
    //결재방식 선택
    handlePayType_Click(event, list) {
        let dtl_cd = list.dtl_cd;
        this.setState({ SelectPayCd: dtl_cd });
        event.preventDefault();

    }
    //주문하기
    async handleSave_Click() {

        if (this.state.SelectOrdCd === "") {
            this.setState({ Content: "주문유형을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'OrderTypeAlert');
            return false;
        }
        if (this.state.SelectPayCd === "") {
            this.setState({ Content: "결재방식을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'OrderTypeAlert');
            return false;
        }
        if (this.state.SelectOrdCd === "TJ" && this.state.Bill_Yn === "N") {
            this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
            Big3Common.ModalAlert(bootstrap, 'BillAlert');
            return false;
        }
       
        //주문관리 마스터
        let OrdMgtMst = [];
        
        this.state.WholeInfo.map(list => {
            OrdMgtMst.push({
                uid: list.uid,
                ord_status: "JM",
                ord_idx:"SP",
                ord_use: this.state.SelectOrdCd,
                pay_idx: this.state.SelectPayCd,
                whole_code: list.whole_code,
                qstgrp_no: this.Qstgrp_no,
                qst_status: this.Qst_status
            });
            return false;
        });
        //주문관리 상세
        let OrdMgtDtl = [];
        this.BasketInfo.map(list => {
            OrdMgtDtl.push({
                uid: list.uid,
                goods_no: list.goods_no,
                crd_cd: list.crd_cd,
                sizgrp_cd: list.sizgrp_cd,
                siz_cd: list.siz_cd,
                quan: list.quan,
                goods_price: list.goods_price
            });
            return false;
        });
        try {
            let Model = { OrdMgtMst: OrdMgtMst, OrdMgtDtl: OrdMgtDtl }
            let Data = await Big3Common.Post('api/MyPage/Basket/RegisterOrdMgtMst ', Model,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                if (this.props.CallBack !== undefined) {
                    this.props.CallBack();
                }
                Big3Common.ModalAlert(bootstrap, 'OrderTypeConfirm');

            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'OrderTypeAlert');

            }
        }
        catch (e) {
            console.log("handleSave_Click", e);
        }
        return false;
    }
    //주문 후 페이지 이동
    handleMove_Click(param) {
        Big3Common.ModalClose(bootstrap, 'OrderTypeConfirm');
        Big3Common.ModalClose(bootstrap, 'OrderType');
        if (param === "OrderMgrList") {
            setTimeout(() => {
                window.location.href = "/MyPage/OrderMgr/Index";
            }, 500);
        }
        else {
            //채팅주문일때
            if (this.Qstgrp_no !== "") {
                setTimeout(() => {
                    window.location.href = "/Chat/ChatList/Index";
                }, 500);
            }
        }
        
    }
    handleAlert_Click() {
        if (this.state.Bill_Yn === "N") {
            this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
            Big3Common.ModalAlert(bootstrap, 'BillAlert');
            return false;
        }
/*        else if (this.state.Refund_Yn === 'Y') {
            this.setState({ Title: "환불 진행중에는 주문이 불가능합니다." });
            Big3Common.ModalAlert(bootstrap, 'BillAlert');
            return false;
        }*/
    }
    //주문유형버튼
    OrdButton(list) {
        return (
            <button
                className={this.state.SelectOrdCd === list.dtl_cd ? "btn2 select" : "btn2"}
                onClick={(e) => { this.handelOrdUse_Click(e, list) }}
                key={list.dtl_cd}
            >
                {list.dtl_nm}
            </button>
        )
    }
    PayTyperender() {
        let DataList = this.state.PayIdx;
        if (DataList.length === 0) return false;
        return (
            <>
                {this.state.SelectOrdCd === 'TJ' ?  
                    <>
                        <div className="desc ordertype_modal_in">
                            <div className="modal_title">결제방식 선택</div>
                        </div>
                        <div className="ordertype_btn_box">
                            {DataList.map(list =>
                                <button className={this.state.SelectPayCd === list.dtl_cd ? "btn2 select" : "btn2"}
                                    key={list.dtl_cd}
                                    onClick={(e) => { this.handlePayType_Click(e, list) }} >{list.dtl_nm}
                                </button>
                            )}
                        </div>
                        <div className="d_info_txt">
                            상품금액은 <span>도매매장으로 직접 입금</span>하셔야합니다. <br></br>
                            택배비는 등록한 카드로 <span>후불결제</span>가 이루어집니다. <br></br>
                            배송기간은 영업일 기준 <span>최대 3일</span>입니다.
                        </div>
                    </>
                    : 
                    <>
                        <div className="desc ordertype_modal_in">
                            <div className="modal_title">결제방식 선택</div>
                        </div>
                        <div className="ordertype_btn_box">
                            {DataList.map(list =>
                                <button className={this.state.SelectPayCd === list.dtl_cd ? "btn2 select" : "btn2"}
                                    key={list.dtl_cd}
                                    onClick={(e) => { this.handlePayType_Click(e, list) }} >{list.dtl_nm}
                                </button>
                            )} 
                        </div>
                    </>
                }
            </>
            )
    }
    //주문유형
    OrdUserender() {
        if (this.Uid_Type === 'SS') {
            let DataList = this.state.OrdUse.filter(list => list.dtl_cd === "HB" || list.dtl_cd === "SS");
            return (
                <div className="ordertype_btn_box">
                    {DataList.map(list => (
                        this.OrdButton(list)
                    ))}
                </div>
            );
        } else {
            let DataList = this.state.OrdUse.filter(list => list.dtl_cd === "HB" || list.dtl_cd === "TJ");
            return (
                <div className="ordertype_btn_box">
                    {DataList.map(list => (
                        this.OrdButton(list)
                    ))}
                </div>
            );
        }
        
    }
    Wholerender() {
        let WholeInfo = this.state.WholeInfo;
        if (WholeInfo.length === 0) return false;
        return (
            <>
                {WholeInfo.map(list =>
                    <div className="shop_info_box" key={list.whole_code}>
                        <div className="shop_box">
                            <div className="shop_name">{list.whole_name}</div>
                            <div className="call" onClick={() => { window.location.href = `tel:${list.user_phone}` }}></div>
                        </div>
                        <div className="bank_name">{list.bank_cd_nm}</div>
                        <div className="acount_number_box">
                            <div className="acount_number">{list.acct_no}</div>
                            <div className="copy" onClick={() => { window.navigator.clipboard.writeText(list.acct_no) } }>복사</div>
                        </div>
                        <div className="acount_info">
                            <div className="acount_holder">예금주 : {list.acct_hodr}</div>
                            <div className="deposit"> 입금액 : {Big3Common.Util.Money(this.PriceSumInfo.filter(price => price.uid === list.uid)[0].pricesum)}원</div>
                        </div>
                    </div>
                 )}
            </>
            )
    }
    Confirmrender() {
        return (
            <div className="modal fade" tabIndex="-1" id="OrderTypeConfirm" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ width: "90%", marginLeft: "5%", backgroundColor: "#efefef" }}>
                        <div className="modal-body text-center">
                            <div className="icon icon-check"></div>
                            <div className="desc">
                                <div className="modal_title">주문이 완료되었습니다</div>
                            </div>
                        </div>
                        <div className="modal-footer mf_v2">
                            <button type="button" className="btn2"
                                onClick={() => { this.handleMove_Click('OrderMgrList')}}>주문상세</button>
                            <button type="button" className="btn2"
                                onClick={() => { this.handleMove_Click('BasketList') }}
                            >주문계속</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    Buttonrender() {
        return (
            <div className="ok_btn_box">
                <button onClick={this.handleSave_Click}>주문하기</button>
            </div>
        );
    }
    render() {
        let OrdUserender = this.OrdUserender();
        let PayTyperender = this.PayTyperender();
        let Wholerender = this.Wholerender();
        let Confirmrender = this.Confirmrender();
        let Buttonrender = this.Buttonrender();
        return (
            <div ref={this.OrderTypeRef} id="OrderType" className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">주문유형 선택</div>
                            </div> 
                            {OrdUserender}
                            {PayTyperender}
                            {Wholerender}
                            {Buttonrender}
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
                <Alert
                    id="OrderTypeAlert"
                    content={this.state.Content}
                    title="주문안내"
                />
                <Alert
                    id="BillAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                {Confirmrender}
            </div>
        );
    }
}
